import { createRouter, createWebHistory } from 'vue-router'
import routeList from 'vue-auto-routing'
import { createRouterLayout } from 'vue-router-layout'
import { isMicroApp, isDev, projectId } from '@/util/env'
import FullPage from '@/layout/fullPage.vue'
import { getUserInfo, token } from '@/provider/global'
import { authority } from '@/provider/authority'

const RouterLayout = createRouterLayout(layout => {
  return import('@/layout/' + layout + '.vue')
})

let base = process.env.VUE_APP_publicPath
if (isMicroApp) {
  base = `/${projectId}/`
}
if (!isMicroApp && isDev) {
  base = '/'
}

const fullRouteList = [], mainRouteList = []
;routeList.forEach(item => {
  const { name } = item
  if(['redirect-404', 'redirect-403', 'account-login', 'query'].includes(name)) {
    fullRouteList.push(item)
  } else {
    mainRouteList.push(item)
  }
})

export const routes = [
  {
    path: '/',
    component: RouterLayout,
    children: mainRouteList
  }, {
    path: '/',
    component: FullPage,
    children: fullRouteList
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/redirect/404'
  }
]

const whiteList = ['/account/login', '/query']

export function useRouter(app) {
  if (!app) return
  const routeInstance = createRouter({
    history: createWebHistory(base),
    routes: routes
  })

  routeInstance.beforeEach(async (to, from, next) => {
    if(whiteList.includes(to.path)) return next()
    if(!token.value) return next('/account/login')
    try {
      await getUserInfo()
    } catch(err) {
      console.log(err)
    }
    const auth = to.meta.auth
    if(auth && !authority(auth)) return next('/redirect/403')
    next()
  })

  app.use(routeInstance)
}